import { mapActions, mapGetters, mapState } from 'vuex'
import { AUTHS } from '@state/modules/auth'

export const authComputed = {
  ...mapState(AUTHS.NAME, {
    currentUser: (state) => state.currentUser,
  }),
  ...mapGetters(AUTHS.NAME, [AUTHS.GET_CURRENT_USER]),
}

export const authMethods = mapActions(AUTHS.NAME, [AUTHS.LOGIN, AUTHS.LOGOUT])
